import { Skeleton } from 'antd';
import React from 'react';

const TableSkeleton = ({ columns = 8, rows = 10, hideHeader = false }) => {
  return (
    <div className="table-responsive" style={{ border: "1px solid #e2e8f0" }}>
      <table className="table table-bordered table-hover mb-0">
        {!hideHeader && (
          <thead style={{ backgroundColor: "#00509d" }}>
            <tr>
              {[...Array(columns)].map((_, i) => (
                <th key={i} className="text-center" style={{ borderBottom: "none", padding: "12px" }}>
                  <Skeleton.Button active size="small" block style={{ background: 'rgba(255,255,255,0.15)' }} />
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {[...Array(rows)].map((_, rowIndex) => (
            <tr key={rowIndex} style={{ backgroundColor: rowIndex % 2 === 0 ? "#ffffff" : "#f8fafc" }}>
              {[...Array(columns)].map((_, colIndex) => (
                <td key={colIndex} className="p-3 align-middle">
                  <Skeleton.Button active size="small" block shape="round" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;
